var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternElement5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 533,
    viewBox: "0 0 526 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_2483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -765,
    width: 630,
    height: 1298
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -765,
    width: 630,
    height: 1297.06,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.44933e-05 315.878L203.764 99.698L407.496 -116.274L203.764 -116.274L407.496 -332.431L611.047 -548.611L815.008 -765L1018.94 -765L815.008 -548.611L611.047 -332.431L815.008 -332.431L1018.94 -332.431L1219.23 -545.365L1219.23 -329.208L1018.94 -116.274L815.008 99.6981L815.008 -116.274L611.047 -116.274L407.496 99.698L203.764 315.878L-0.000113392 532.059L-9.44933e-05 315.878ZM409.021 315.978L612.202 99.8952L815.775 315.978L1019.3 99.8953L1219.24 -112.526L1219.24 103.557L1019.3 315.978L815.775 532.061L612.202 315.978L409.021 532.061L205.676 532.061L409.021 315.978Z",
    fill: "url(#paint0_linear_3_2483)",
    fillOpacity: 0.99
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2483",
    x1: 609.617,
    y1: 532.061,
    x2: 609.617,
    y2: -765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.99
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternElement5);
export default __webpack_public_path__ + "static/media/Pattern Element 5.a57bb83d776a970f95d05f90f49baee4.svg";
export { ForwardRef as ReactComponent };